<template>
  <!-- 响应的陪玩师列表，卡片 -->
  <div v-if="master" class="quick-order-master">
    <div class="master-avatar" @click="openMasterDetailPage">
      <img :src="master.avatarUrl + '?d=600x600'" alt="" />
      <div
        class="top-tag"
        :class="{ reduce: master.reducePrice && isSelf }"
      ></div>
      <!-- <div
        :class="{
          tag: true,
          [tagId]: true
        }"
      ></div> -->
      <fps-icon
        class="icon"
        type="photo-verify"
        color="#409AFF"
        v-if="master && master.faceSuccess && !master.titleEditable"
      />
      <div
        v-if="commentLabelList && commentLabelList.length"
        class="comment-label-box"
      >
        <div
          class="comment-label"
          v-for="item of commentLabelList"
          :key="item.name"
        >
          {{ item.name }}
          <span class="count">{{ item.count }}</span>
        </div>
      </div>
    </div>
    <div class="master-info">
      <div class="info-top">
        <div class="master-name">
          <span class="nick-name">{{ master.nickname }}</span>
          <div class="right">
            <div v-if="showTags.length" class="tags-wrap">
              <div v-for="tag in showTags" :key="tag.id" :class="tag.classes">
                {{ tag.onlyShowIamge ? '' : tag.name }}
              </div>
            </div>
            <!-- <div v-if="isSelf" class="chat" @click.stop="openChat"></div> -->
          </div>
        </div>
        <Voice
          v-if="master.userVoiceUrl"
          class="master-voice"
          :times="master.voiceTimeLength"
          :voice-url="master.userVoiceUrl"
          :skill="master.skillId"
          :uuid="master.userUuid"
        />
        <div v-else-if="master.textContent" class="user-text-content">
          <p>{{ master.textContent }}</p>
        </div>
        <div class="redbag-info" v-if="master.hbAmount">
          {{ master.hbBest ? '👑LUCKY! ' : '🧧' }}{{$t('upgrade_page_views_quick_order_quick_order_master_1330',[master.hbAmount])}}
        </div>
      </div>
      <div
        :class="{
          'info-bot': true,
          'not-self': !isSelf
        }"
      >
        <div class="left">
          <div class="price-box">
            <p class="master-price">
              <span class="coupon-tag" v-if="hasNewCoupon && couponText"
                >{{ couponText }} </span
              >{{ master.currencyKind }}{{ currentPrice }}/{{
                master.salesUnit | salesUnitTranslate
              }}
            </p>
            <p
              v-if="master.currentPrice < master.originPrice && isSelf"
              class="master-origin-price"
            >
              {{ master.currencyKind }}{{ master.originPrice }}/{{
                master.salesUnit | salesUnitTranslate
              }}
            </p>
          </div>
          <p class="master-order-detail">
            <span class="order-count" v-if="master"
              >{{$t('upgrade_page_views_quick_order_quick_order_master_1326', [ master.countTransactions ])}}</span
            >
            <span class="repurchase-rate" v-if="repurchaseRate"
              >{{$t('upgrade_page_views_quick_order_quick_order_master_1327', [ repurchaseRate ])}}</span
            >
          </p>
          <!-- <p>接單{{ master.countTransactions }}次</p> -->
        </div>
        <div class="right">
          <button v-if="isSelf" @click.stop="setPreOrder()" class="button">{{$t('upgrade_page_views_quick_order_quick_order_master_1328')}}</button>
          <!-- 即使是圍觀身份，也有可能在列表里看到自己的卡片 -->
          <div
            v-else-if="userInfo.uuid !== master.userUuid"
            class="follow"
            @click.stop="handleFollowUser"
          >
            <img v-show="!master.followed" src="./images/icon-follow.png" />
            <img v-show="master.followed" src="./images/icon-followed.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';
import { followUser } from '@/api';
import Voice from './quick-order-voice';
import { Encrypt } from '@/utils/crypto-aes';

export default {
  components: {
    Voice
  },
  props: {
    master: {
      type: Object,
      default() {
        return null;
      }
    },
    quickMatchUuid: String,
    count: Number,
    hasNewCoupon: Boolean, // 是否還有優惠券
    isSelf: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      nowToast: null,
      skillInfo: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'newerCoupon']),
    tagId() {
      let tagList = this.master.labelList || [{ id: 0 }];
      let tag;
      if (this.master.newPlayer) {
        tag = 'new';
      }
      if (tagList[0] && tagList[0].id) {
        tag = 'tag' + tagList[0].id;
      }
      if (this.master.reducePrice && this.isSelf) {
        tag = 'reduce';
      }
      return tag;
    },
    showTags() {
      const list = [];
      // const labelList = [
      //   {
      //     gameId: 38,
      //     labelId: 13,
      //     labelType: 'Default',
      //     showType: 'Default',
      //     labelName: 'PlayerHot'
      //   },
      //   {
      //     gameId: 38,
      //     labelData: '0.58',
      //     labelId: 10,
      //     labelType: 'Default',
      //     showType: 'Default',
      //     labelName: 'Repurchase'
      //   }
      // ];
      const labelList = this.master.labelList;
      const tagsCustom = this.$util
        .computedTags(labelList, 'custom')
        .filter(item => item.id !== 12)
        .sort(this.compare('id'));
      const tagsComment = this.$util.computedTags(labelList, 'comment');
      if (tagsComment[0]) {
        list.push(tagsComment[0]);
      }
      if (tagsCustom[0]) {
        list.unshift(...tagsCustom.slice(0, 2 - list.length));
      }
      return list && list[0] ? [list[0]] : [];
    },
    couponText() {
      if (this.master.quickMatchPriceType === 'SELF_PRICE') return i18n.t('upgrade_page_views_player_list_player_item_170');
      if (!this.isSelf) return '';
      return i18n.t('upgrade_page_views_quick_order_quick_order_master_1329');
    },
    currentPrice() {
      if (!this.hasNewCoupon) return this.master.currentPrice;
      let price = 0;
      if (this.newerCoupon) {
        price = this.master.currentPrice - this.newerCoupon.couponAmount;
      } else {
        price = this.master.currentPrice;
      }
      return price < 0 ? 0 : price;
    },
    //輔購率
    repurchaseRate() {
      return this.master ? Math.trunc(this.master.repurchaseRate * 100) : 0;
    },
    commentLabelList() {
      let result = [];
      try {
        if (this.master) {
          const data = JSON.parse(this.master.commentLabel);
          // const data = { name: '聲音好聽', count: '42' };
          if (Array.isArray(data)) {
            result = data;
          } else if (typeof data === 'object' && data !== null) {
            result.push(data);
          }
        }
      } catch (error) {
        console.error(error);
      }
      if (result.length > 2) {
        result = result.slice(0, 2);
      }
      // return [...result, ...result];
      return result;
    }
  },
  methods: {
    compare(prop) {
      return function(obj1, obj2) {
        const val1 = obj1[prop];
        const val2 = obj2[prop];
        //回單王 新人 高人气 夯口碑
        if (val1 === 15 && val2 !== 10) {
          return -1;
        }
        if (val2 === 15 && val1 !== 10) {
          return 1;
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    openMasterDetailPage() {
      const { master, count } = this;
      sessionStorage.setItem('QUICK_MATCH_ORDER_COUNT', count);
      this.$emit('openskilldetail', {
        skillInfo: master
      });
    },
    setPreOrder(quickMatchRandom) {
      const {
        master: { skillId, skillPriceId },
        quickMatchUuid,
        count
      } = this;
      let url = `/order/check/${skillId}/${count}?quickMatchUuid=${quickMatchUuid}`;
      if (skillPriceId && skillPriceId > 0) {
        url += `&price=${skillPriceId}`;
      }
      localStorage.setItem(
        'quickMatchRandom',
        quickMatchRandom ? Encrypt(quickMatchUuid) : ''
      );
      this.$util.openWindow(url);
    },
    handleFollowUser() {
      if (this.loading) return;
      this.loading = true;
      const { uuid, followed } = this.master;
      followUser({
        followOptType: followed ? 'Unfollow' : 'Follow',
        uuid
      }).then(() => {
        if (!followed) {
          if (this.nowToast) {
            this.nowToast.close();
          }
          this.nowToast = this.$message.success(i18n.t('upgrade_page_views_master_components_some_handle_219'));
        }
        this.$emit('changeFollow', !followed);
        this.loading = false;
      });
    },
    openChat() {
      this.$util.openChatWindow(this.userInfo.uuid, this.master.uuid);
    }
  }
};
</script>

<style lang="scss" scoped>
.quick-order-master {
  @include flex(space-between, stretch);
  width: 100%;
  border-radius: 10px;
  background: white;
  overflow: hidden;
}
.price-box {
  display: flex;
  align-items: center;
  .master-origin-price {
    margin-left: 10px;
  }
}
.master-info {
  @include flex(space-between, flex-start, column);
  flex-grow: 1;
  overflow: hidden;
  .info-top {
    width: 100%;
    overflow: hidden;
    .master-name {
      display: flex;
      align-items: center;
      width: 100%;
      height: 22px;
      font-size: 16px;
      color: #333;
      font-weight: 600;
      line-height: 22px;
      justify-content: space-between;
      span {
        flex-grow: 1;
        @include ellipsis(1);
      }
      .nick-name {
        max-width: 300px;
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: none;
        .tags-wrap {
          display: flex;
          align-items: center;
          > div {
            margin-left: 10px;
          }
        }
      }
      .chat {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        margin-left: 10px;
        background: url('./images/icon-chat.png') center center no-repeat;
        background-size: 20px 20px;
        cursor: pointer;
        &:hover,
        &:active {
          background: url('./images/icon-chat-hover.png') center center
            no-repeat;
          background-size: 20px 20px;
        }
      }
    }
    .user-text-content {
      margin-top: 12px;
      padding: 8px 6px;
      background: #f5f9ff;
      border: 1px solid #dee1e7;
      border-radius: 10px;
      border-top-left-radius: 0;
      font-size: 12px;
      line-height: 17px;
      color: #586884;
      @include ellipsis(3);
      // float: left;
    }
    .master-voice {
      position: relative;
      margin-top: 12px;
    }
    .redbag-info {
      margin-top: 10px;
      margin-bottom: 8px;
      color: #828282;
      font-size: 10px;
      display: flex;
      align-items: center;
      .hbBest {
        color: #fed838;
        display: inline-flex;
        align-items: center;
      }
    }
  }
  .info-bot {
    @include flex(space-between);
    width: 100%;
    font-size: 14px;
    text-align: left;
    align-items: flex-end;
    .left {
      padding-bottom: 1px;
    }
    p {
      line-height: 12px;
      font-size: 10px;
      color: #323d4f;
      margin-top: 3px;
      transform-origin: 0 100%;
      &:first-child {
        font-size: 14px;
        line-height: 17px;
        font-size: 12px;
        font-weight: 500;
        color: #fa006e;
        margin-top: 0;
      }
      &.master-origin-price {
        text-decoration: line-through;
      }
    }
    button {
      width: 70px;
      height: 34px;
      font-size: 14px;
      line-height: 34px;
      border-radius: 44px;
      cursor: pointer;
      background: #fa006e;
      color: #fff;
      &:active,
      &:hover {
        background: #e10063;
      }
    }
    .follow {
      width: 28px;
      height: 28px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.master-avatar {
  position: relative;
  flex-shrink: 0;
  background: #e8e8e8;
  overflow: hidden;
  .icon {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
  }
  .comment-label-box {
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 5px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    font-size: 12px;
    flex: auto;
    .comment-label {
      flex: none;
      background-color: rgba($color: #000, $alpha: 0.4);
      color: rgba($color: #fff, $alpha: 0.9);
      height: 18px;
      line-height: 18px;
      border-radius: 4px;
      padding: 0 4px;
      &:nth-child(2) {
        margin-left: 4px;
      }
    }
    overflow: hidden;
  }
}
.master-order-detail {
  span {
    &:nth-child(2) {
      display: inline-block;
      margin-left: 10px;
    }
  }
}

.top-tag {
  position: absolute;
  z-index: 1;
  border-radius: 2px;
  font-size: 10px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  font-weight: 500;
  &.reduce {
    left: 6px;
    top: 6px;
    padding: 0 3px;
    background: #a9e6af;
    &::before {
      content: none;
    }
    &::after {
      content: '為您降價';
      color: #2c7032;
    }
  }
}

@media screen and(min-width: 600px) {
  .master-avatar {
    width: 166px;
    height: 166px;
    cursor: pointer;
    img {
      width: auto;
      height: 100%;
    }
  }
  .master-info {
    padding: 14px;
  }
  .user-text-content {
    max-width: 230px;
  }
}

@media screen and(max-width: 599px) {
  .master-avatar {
    width: 40vw;
    height: 44vw;
    img {
      width: auto;
      height: 100%;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
  .master-info {
    padding: 14px 12px;
  }
}
</style>
